import { defineStore } from 'pinia';

/**
 * Shared store for managing application state.
 */
export const useSharedStore = defineStore('shared', {
    state: () => ({
        breadcrumbs: [],
        isLoading: false,
        loadingText: '',
        // notification popups. See watchers in App.vue for usage.
        notification: {
            type: null, // valid types: 'success', 'error'
            message: null
        }
    }),

    actions: {
        /**
         * Resets the state to its default values.
         */
        resetState() {
            this.$reset();
        },

        /*******************
         * Loading actions *
         *******************/

        /**
         * Handles showing a loading animation.
         */
        beginLoading(loadingText = '') {
            this.isLoading = true;
            this.loadingText = loadingText;
        },
        /**
         * Handles removing a loading animation.
         */
        stopLoading() {
            this.isLoading = false;
            this.loadingText = '';
        },

        /**********************
         * Breadcrumb actions *
         **********************/

        /**
         * Sets breadcrumbs.
         */
        setBreadcrumbs(breadcrumbs) {
            this.breadcrumbs = [...breadcrumbs];
        },
        /**
         * Pushes a new breadcrumb.
         */
        pushBreadcrumb(breadcrumb) {
            this.breadcrumbs.push({ ...breadcrumb });
        },
        /**
         * Pops the last breadcrumb.
         */
        popBreadcrumb() {
            this.breadcrumbs.pop();
        },
        /**
         * Clears breadcrumbs.
         */
        clearBreadcrumbs() {
            this.breadcrumbs = [];
        },

        /************************
         * Notification actions *
         ************************/

        /**
         * Sets notification.
         * @param {Object} notification
         * @param {string} notification.message - Message to show user.
         * @param {string} notification.type - Type of notification (determines style).
         */
        setNotification(notification) {
            this.notification = { ...notification };
        },
        /**
         * Clears notification.
         */
        clearNotification() {
            this.notification = {
                type: null,
                message: null
            };
        }
    }
});
